<template>
  <div class="filebrowser" @ondrop="setFile">
    <UploadIcon class="icon" />
    Загрузить файл
    <input type="file" :accept="data.req" @change="setFile" multiple />
  </div>
</template>

<script>
import UploadIcon from '@/assets/svg/upload-icon.svg?inline'

export default {
  components: {
    UploadIcon
  },
  props: {
    data: Object,
  },
  methods: {
    setFile (e) {
      const th = this;
      e.target.files.forEach((file, i) => {
        const reader = new FileReader();
        reader.onload = function() {
          th.$emit('set', { name: e.target.files[i].name, value: reader.result })
        }
        reader.readAsDataURL(file);
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.filebrowser{
  @include box(100%, 100%, relative, null, null, null, null, null, $filebrowser);
  @include flex(center, center, column);
  @include border(0.04vw, dashed, $filebrowserBorder, null, null, null, null);
  @include padding(2vw, 2vw, 2vw, 2vw);
  @include text(0.8vw, 500, 0.08vw, null, center, $filebrowserColor);
  text-transform: uppercase;
  cursor: pointer;
  .icon{
    @include size(2vw, 2vw);
    @include margin(0, 0, 0, 1vw);
  }
  &:hover{
    @include border(null, null, $filebrowserBorderHover, null, null, null, null);
    @include text(null, null, null, null, center, $filebrowserColorHover);
  }
  input{
    @include box(100%, 100%, absolute, 0, 0, null, null, null, null);
    z-index: 2;
    cursor: pointer;
    opacity: 0;
  }
}
</style>
